import React from 'react'
import {
  Caps2,
  Pane,
  majorScale,
  theme
} from '@segment/react-ui-library'
import Card from './Card'
import CardHeader from './CardHeader'
import Heatmap from './Heatmap'

const levels = [
  { min: 0, max: 0, color: theme.rawColors.grey200 },
  { min: 1, max: 24, color: '#81D6AD' },
  { min: 25, max: 49, color: theme.rawColors.green400 },
  { min: 50, max: 99, color: theme.rawColors.green600 },
  { min: 100, max: Infinity, color: theme.rawColors.green700 }
]

const Circle = props => <Pane {...props} />

Circle.defaultProps = {
  width: '8px',
  height: '8px',
  marginX: '1px',
  circle: true
}

const ActivitiesCard = ({ skeleton = false, events }) => {
  return (
    <Card>
      <CardHeader title='Activity'>
        <Pane display='flex' alignItems='center'>
          <Caps2 marginRight={majorScale(1)}>Less</Caps2>
          {levels.map(level => <Circle key={level.max} style={{ background: level.color }} />)}
          <Caps2 marginLeft={majorScale(1)}>More</Caps2>
        </Pane>
      </CardHeader>
      <Pane tint padding={majorScale(2)}>
        <Activities skeleton={skeleton} events={events} levels={levels} />
      </Pane>
    </Card>
  )
}

const Activities = ({ skeleton, events = {}, levels }) => {
  const values = {}

  Object.keys(events).forEach(e => {
    const event = events[e]
    const { daily } = event
    Object.keys(daily).forEach(timestamp => {
      const count = daily[timestamp]
      const existingCount = values[timestamp] || 0
      values[timestamp] = count + existingCount
    })
  })

  return <Heatmap skeleton={skeleton} values={values} levels={levels} />
}

export default ActivitiesCard



// WEBPACK FOOTER //
// ./components/Customers/presentational/ActivitiesCard.js